import React from 'react';
import classNames from 'classnames';
import { IconTopAdvisor, IconUpcoming } from '../';
import css from './UserBadge.module.css';

const BADGE_TYPES = {
  'top-advisor': {
    icon: IconTopAdvisor,
    label: 'Top Advisor',
  },
  'upcoming': {
    icon: IconUpcoming,
    label: 'Upcoming',
  },
};

/**
 * User badge component for displaying user achievements or status.
 *
 * @component
 * @param {Object} props
 * @param {string} props.type badge type ('top-advisor' or 'upcoming')
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean?} props.showLabel whether to show the label text
 * @param {string?} props.title custom title for the badge (for tooltips)
 * @returns {JSX.Element} badge component
 */
const UserBadge = props => {
  const { type, className, rootClassName, showLabel = true, title } = props;
  const classes = classNames(rootClassName || css.root, className);

  const badgeConfig = BADGE_TYPES[type];
  if (!badgeConfig) {
    return null;
  }

  const { icon: IconComponent, label } = badgeConfig;
  const badgeTitle = title || label;

  return (
    <div className={classes} title={badgeTitle}>
      <IconComponent className={css.icon} />
      {showLabel && <span className={css.label}>{label}</span>}
    </div>
  );
};

export default UserBadge;
